import { render, staticRenderFns } from "./patients-operations.html?vue&type=template&id=6bc71600&scoped=true&external"
import script from "./patients-operations.js?vue&type=script&lang=js&external"
export * from "./patients-operations.js?vue&type=script&lang=js&external"
import style0 from "./patients-operations.scss?vue&type=style&index=0&id=6bc71600&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc71600",
  null
  
)

export default component.exports